"use strict";
/**
 * Copyright (c) 2017-present, Ephox, Inc.
 *
 * This source code is licensed under the Apache 2 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ScriptLoader = require("../ScriptLoader");
var TinyMCE_1 = require("../TinyMCE");
var Utils_1 = require("../Utils");
var EditorPropTypes_1 = require("./EditorPropTypes");
var scriptState = ScriptLoader.create();
var Editor = /** @class */ (function (_super) {
    __extends(Editor, _super);
    function Editor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.element = null;
        _this.initialise = function () {
            var finalInit = __assign({}, _this.props.init, { target: _this.element, readonly: _this.props.disabled, inline: _this.inline, plugins: Utils_1.mergePlugins(_this.props.init && _this.props.init.plugins, _this.props.plugins), toolbar: _this.props.toolbar || (_this.props.init && _this.props.init.toolbar), setup: function (editor) {
                    _this.editor = editor;
                    editor.on('init', function (e) {
                        _this.initEditor(e, editor);
                    });
                    if (_this.props.init && typeof _this.props.init.setup === 'function') {
                        _this.props.init.setup(editor);
                    }
                } });
            if (Utils_1.isTextarea(_this.element)) {
                _this.element.style.visibility = '';
            }
            TinyMCE_1.getTinymce().init(finalInit);
        };
        return _this;
    }
    Editor.prototype.componentWillMount = function () {
        this.id = this.id || this.props.id || Utils_1.uuid('tiny-react');
        this.inline = this.props.inline ? this.props.inline : this.props.init && this.props.init.inline;
    };
    Editor.prototype.componentDidMount = function () {
        if (TinyMCE_1.getTinymce() !== null) {
            this.initialise();
        }
        else if (this.element && this.element.ownerDocument) {
            var doc = this.element.ownerDocument;
            var channel = this.props.cloudChannel;
            var apiKey = this.props.apiKey ? this.props.apiKey : '';
            ScriptLoader.load(scriptState, doc, "https://cloud.tinymce.com/" + channel + "/tinymce.min.js?apiKey=" + apiKey, this.initialise);
        }
    };
    Editor.prototype.componentWillUnmount = function () {
        if (TinyMCE_1.getTinymce() !== null) {
            TinyMCE_1.getTinymce().remove(this.editor);
        }
    };
    Editor.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.editor && this.editor.initialized) {
            this.currentContent = this.currentContent || this.editor.getContent();
            if (typeof nextProps.value === 'string' && nextProps.value !== this.props.value && nextProps.value !== this.currentContent) {
                this.editor.setContent(nextProps.value);
            }
            if (typeof nextProps.disabled === 'boolean' && nextProps.disabled !== this.props.disabled) {
                this.editor.setMode(nextProps.disabled ? 'readonly' : 'design');
            }
        }
    };
    Editor.prototype.render = function () {
        return this.inline ? this.renderInline() : this.renderIframe();
    };
    Editor.prototype.initEditor = function (initEvent, editor) {
        var _this = this;
        var value = typeof this.props.value === 'string' ? this.props.value : typeof this.props.initialValue === 'string' ? this.props.initialValue : '';
        editor.setContent(value);
        if (Utils_1.isFunction(this.props.onEditorChange)) {
            editor.on('change keyup setcontent', function (e) {
                _this.currentContent = editor.getContent();
                if (Utils_1.isFunction(_this.props.onEditorChange)) {
                    _this.props.onEditorChange(_this.currentContent);
                }
            });
        }
        Utils_1.bindHandlers(this.props, editor, initEvent);
    };
    Editor.prototype.renderInline = function () {
        var _this = this;
        var _a = this.props.tagName, tagName = _a === void 0 ? 'div' : _a;
        return React.createElement(tagName, {
            ref: function (elm) { return (_this.element = elm); },
            id: this.id
        });
    };
    Editor.prototype.renderIframe = function () {
        var _this = this;
        return React.createElement("textarea", { ref: function (elm) { return (_this.element = elm); }, style: { visibility: 'hidden' }, id: this.id, name: this.props.textareaName });
    };
    Editor.propTypes = EditorPropTypes_1.EditorPropTypes;
    Editor.defaultProps = {
        cloudChannel: '5'
    };
    return Editor;
}(React.Component));
exports.Editor = Editor;



//////////////////
// WEBPACK FOOTER
// ./~/@tinymce/tinymce-react/lib/cjs/components/Editor.js
// module id = 586
// module chunks = 0